/** A single entry in the dashboard quick-navigation list. */
export interface IQuickNavLink {
  label: string;
  toLink: string;
}

/**
 * Ordered list of quick-navigation links rendered on the Dashboard.
 * Each entry is rendered as a styled list item that respects `RequireAccess` route guards.
 */
export const quickNavLinks: IQuickNavLink[] = [
  { label: 'Mobile', toLink: '/mobile' },
  { label: 'Clients', toLink: '/clients' },
  { label: 'Commissions', toLink: '/commissions/commissions_tabs' },
  { label: 'Fees', toLink: '/fees' },
  { label: 'Invoices', toLink: '/invoices' },
  { label: 'Reporting', toLink: '/reporting' },
];
